import { render, staticRenderFns } from "./ExternalFooter.vue?vue&type=template&id=661b9578&scoped=true&"
import script from "./ExternalFooter.vue?vue&type=script&lang=js&"
export * from "./ExternalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExternalFooter.vue?vue&type=style&index=0&id=661b9578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b9578",
  null
  
)

export default component.exports